import NestedRoute from '@/components/NestedRoute/index.vue'

import { DynamicImportReturnType } from './types'

/**
 * 支付能力承载页面对应的路由
 */
export const paymentRoutes = {
  path: '/payment',
  component: NestedRoute,
  children: [
    {
      path: 'common',
      name: 'CommonPayment',
      component: (): DynamicImportReturnType =>
        import('@/pages/payment/Common/index.vue'),
      // alias: '/Customer/Payment/',
      meta: {
        title: '正在支付',
      },
    },
    {
      path: 'unionPayCreditCardInstallment',
      component: NestedRoute,
      children: [
        {
          path: '',
          name: 'CreditCardInstallmentInfo',
          component: (): DynamicImportReturnType =>
            import('@/pages/payment/UnionPayCreditCardInstallment/index.vue'),
          meta: {
            title: '信用卡分期',
          },
        },
        {
          path: 'card',
          name: 'CreditCardInfo',
          component: (): DynamicImportReturnType =>
            import('@/pages/payment/UnionPayCreditCardInstallment/index.vue'),
          meta: {
            title: '信用卡分期',
          },
        },
      ],
    },
    {
      path: 'bankTransfer',
      name: 'BankTransferPayment',
      component: (): DynamicImportReturnType =>
        import('@/pages/payment/BankTransfer/index.vue'),
      meta: {
        title: '网银转账',
      },
    },
    {
      path: 'zftSchool',
      name: 'ZFTSchoolPayment',
      component: (): DynamicImportReturnType =>
        import('@/pages/payment/ZFTSchool/index.vue'),
      meta: {
        title: '支付宝教育缴费',
      },
    },
  ],
}
